<h2 mat-dialog-title>{{'DIALOG_TITLE' | translate}}</h2>
<mat-dialog-content>
  <p>{{'DIALOG_BODY_BACK' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="matbtncontinue" (click)="back()" mat-raised-button>{{'DIALOG_BACK_CONTUNUE' | translate}}</button>
  <button mat-button class="matbtncontinue" (click)="close()" mat-raised-button>{{'DIALOG_BACK_CANCEL' | translate}}</button>
</mat-dialog-actions>

